import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumPayroll } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/payroll/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.payroll'
  });
  useDocumentTitle(t('pageTitle'));
  const matchRoute = useMatchRoute();
  /** 従業員給与明細詳細は `EmployeePaySlipDetailHeader` 専用のため、モジュールの ListPageHeader は出さない */
  const isEmployeePaySlipDetail = matchRoute({
    to: '/payroll/pay-slips/$employeeId',
    fuzzy: true
  });
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isEmployeePaySlipDetail ? <ListPageHeader icon={<ProductLogoMediumPayroll />} title={t('pageTitle')} tabs={[{
      to: '/payroll/overview',
      children: t('tabs.overview'),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/payroll/pay-slips',
      children: t('tabs.paySlips'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/payroll/contract-and-cost',
      children: t('tabs.contractAndCost'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/payroll/alerts',
      children: t('tabs.alerts'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/payroll/rule-and-policy',
      children: t('tabs.ruleAndPolicy'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/payroll/settings',
      children: t('tabs.settings'),
      activeOptions: {
        exact: false
      }
    }]} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>;
}